import { minorUnitExponent, PLATFORM_CURRENCY } from "@dentacore/shared-types";

/** A platform price for display: `$13.00`, or the currency code before it when no symbol applies. */
export function priceText(cents: number): string {
  const exponent = minorUnitExponent(PLATFORM_CURRENCY);
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: PLATFORM_CURRENCY,
    }).format(cents / 10 ** exponent);
  } catch {
    return `${PLATFORM_CURRENCY} ${(cents / 10 ** exponent).toFixed(exponent)}`;
  }
}

/**
 * A typed amount as minor units, or null when it is not one. **Refuses more
 * decimals than the currency has** rather than rounding, and is built from the
 * digits, never by multiplying a float.
 */
export function priceCents(text: string): number | null {
  const exponent = minorUnitExponent(PLATFORM_CURRENCY);
  const match = /^(\d{1,9})(?:\.(\d+))?$/.exec(text.trim());
  if (match === null) return null;
  const whole = match[1] ?? "0";
  const fraction = match[2] ?? "";
  if (fraction.length > exponent) return null;
  return Number(whole + fraction.padEnd(exponent, "0"));
}
